import { api } from '@/core/api/';
const apiUrl = 'api/requisitionmanagment';
import qs from 'querystring';

export default {
  getAcademicyears() {
    return api.get(`${apiUrl}/academicyears`);
  },
  getStatuses() {
    return api.get(`${apiUrl}/statuses`);
  },
  search(params) {
    return api.get(`${apiUrl}/search`, { params });
  },
  saveBinnacle(payload) {
    return api.post(`${apiUrl}/addbinacle`, payload);
  },
  getBinnacle(params) {
    return api.get(`${apiUrl}/binnacles`, { params: { ...params } });
  },
  getRequisitionDetail(requisitionId) {
    return api.get(`${apiUrl}/detail/${requisitionId}`);
  },
  getRequisitionSources() {
    return api.get(`${apiUrl}/sources`);
  },
  getAdditionalInfo(id) {
    return api.get(`${apiUrl}/additionalInfo/${id}`);
  },
  getRequisitionDocuments(id) {
    return api.get(`${apiUrl}/${id}/documents`);
  },
  getRequisitions(peiAtServiceId) {
    return api.get(`${apiUrl}/${peiAtServiceId}`);
  },
  saveRequisition(data) {
    return api.post(`${apiUrl}/save`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getAdditionalDocuments(peiAtServiceId) {
    return api.get(`${apiUrl}/additionaldocuments/${peiAtServiceId}`);
  },
  getAudiologicalEvaluation(peiAtServiceId) {
    return api.get(`${apiUrl}/audiologicaevaluation/${peiAtServiceId}`);
  },
  sync(id, peiAtServiceId) {
    return api.get(`${apiUrl}/${id}/sync/${peiAtServiceId}`);
  },
  update(id, payload) {
    return api.put(`${apiUrl}/${id}`, payload);
  },
  delete(id) {
    return api.delete(`${apiUrl}/${id}`);
  },
  getConfSideEquipments(equipmentIds) {
    return api.get(`${apiUrl}/conf/sifde/equipments`, {
      params: {
        equipmentIds,
      },
      paramsSerializer: (q) => {
        return qs.stringify(q);
      },
    });
  },
};
